import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { ModalFormSection, ModalFooter } from 'components/common/modals';
import styles from './addPartnerForm.style';

import {
  editValidationSchema,
  createValidationSchema,
} from './validationSchema';

const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  phoneNumbers: [
    {
      phoneNumber: '',
      isDefault: true,
    },
  ],
};
const AddEditPartnerForm = ({
  onSubmit,
  onCancel,
  defaultValues,
  isLoading,
}) => {
  const isEdit = Boolean(defaultValues);

  const resolver = yupResolver(
    isEdit ? editValidationSchema : createValidationSchema
  );

  const methods = useForm({
    resolver,
    defaultValues: defaultValues || INITIAL_VALUES,
  });

  useEffect(() => {
    methods.reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useEffect(() => {
    return () => {
      methods.reset(INITIAL_VALUES);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        id="add-edit-partner-form"
      >
        <ModalFormSection>
          <Box sx={styles.row}>
            <FieldV2
              label="First Name"
              name="firstName"
              control={methods.control}
              disabled={methods.formState.isSubmitting}
              isRequired={!isEdit}
            />
            <FieldV2
              label="Last Name"
              name="lastName"
              control={methods.control}
              disabled={methods.formState.isSubmitting}
              isRequired={!isEdit}
            />
          </Box>
          <Box sx={styles.row}>
            <FieldV2
              label="Email"
              name="email"
              control={methods.control}
              disabled={isEdit || methods.formState.isSubmitting}
              isRequired={!isEdit}
            />
          </Box>
          <Box sx={styles.row}>
            <FieldV2
              label="Phone Number"
              name="phoneNumbers.0.phoneNumber"
              control={methods.control}
              isRequired
              placeholder="e.g. +30xxxxxxxxxx"
              disabled={methods.formState.isSubmitting}
            />
          </Box>
          <Box sx={styles.row}>
            <FieldV2
              label="Password"
              name="password"
              type="password"
              disabled={methods.formState.isSubmitting}
              control={methods.control}
              isRequired={!isEdit}
            />
          </Box>
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2
            variant="outlined"
            onClick={onCancel}
            loading={methods.formState.isSubmitting || isLoading}
          >
            Cancel
          </ButtonV2>
          <ButtonV2
            type="submit"
            loading={methods.formState.isSubmitting || isLoading}
            form="add-edit-partner-form"
            disabled={!methods.formState.isDirty}
          >
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default AddEditPartnerForm;
